import DesignShell from '../components/DesignShell';
import siteSetup from '../content/site/site-setup.md?raw';

export default function Setup() {
  return (
    <DesignShell
      title="Site Setup"
      subtitle="How the Synergy master-record site is built and hosted — Azure resources, deploy pipelines, variable groups, RBAC, and repo layout."
      markdown={siteSetup}
    />
  );
}
